import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import { Toaster } from 'sonner'
import ErrorBoundary from './components/ErrorBoundary.jsx'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import { ThemeProvider, getThemeFromUser } from './contexts/ThemeContext'
import { AuthThemeProvider } from './contexts/AuthThemeContext'
import './index.css'
import { router } from './router'

/**
 * ThemeWrapper connects AuthContext to ThemeProvider.
 * Extracts theme info from the authenticated user's organization.
 */
function ThemeWrapper({ children }) {
  const { user } = useAuth();
  const { theme, organizationName, logoUrl } = getThemeFromUser(user);

  return (
    <ThemeProvider theme={theme} organizationName={organizationName} logoUrl={logoUrl}>
      {children}
    </ThemeProvider>
  );
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <AuthProvider>
      <AuthThemeProvider>
        <ThemeWrapper>
          <ErrorBoundary>
            <Toaster richColors position="top-right" />
            <RouterProvider router={router} />
          </ErrorBoundary>
        </ThemeWrapper>
      </AuthThemeProvider>
    </AuthProvider>
  </StrictMode>,
)
